import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCertifiedOutline from '@adv-mt/mt-svg-icons/lib/CertifiedOutline.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import IconHandShakeOutline from '@adv-mt/mt-svg-icons/lib/HandShakeOutline.js'
import IconLockOutline from '@adv-mt/mt-svg-icons/lib/LockOutline.js'
import IconShieldUserOutline from '@adv-mt/mt-svg-icons/lib/ShieldUserOutline.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const SellerCheckContractsTransactionModal = () => {
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/tramites-y-servicios.svg`

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionSellerCheckContractsModal-modalContainer">
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionSellerCheckContractsModal-modalChildren">
                  <div className="mt-TransactionSellerCheckContractsModal-description">
                    {i18n.t('VEHICLE_TRANSACTION.CHECK_CONTRACTS.MAIN_TEXT')}
                  </div>
                  <div className="mt-TransactionSellerCheckContractsModal-contentWrapper mt-TransactionSellerCheckContractsModal-contentWrapper--withIcon">
                    <div className="mt-TransactionSellerCheckContractsModal-contentIcon">
                      <IconHandShakeOutline size={ATOM_ICON_SIZES.medium} />
                    </div>
                    <div className="mt-TransactionSellerCheckContractsModal-contentText">
                      <div className="mt-TransactionSellerCheckContractsModal-contentTextTitle">
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.CONTRACT.TITLE')}
                      </div>
                      <span>{i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.CONTRACT.DESCRIPTION')}</span>
                    </div>
                  </div>
                  <div className="mt-TransactionSellerCheckContractsModal-contentWrapper mt-TransactionSellerCheckContractsModal-contentWrapper--withIcon">
                    <div className="mt-TransactionSellerCheckContractsModal-contentIcon">
                      <IconLockOutline size={ATOM_ICON_SIZES.medium} />
                    </div>
                    <div className="mt-TransactionSellerCheckContractsModal-contentText">
                      <div className="mt-TransactionSellerCheckContractsModal-contentTextTitle">
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.DEPOSIT_CONTRACT.TITLE')}
                      </div>
                      <span>
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.DEPOSIT_CONTRACT.DESCRIPTION')}
                      </span>
                    </div>
                  </div>
                  <div className="mt-TransactionSellerCheckContractsModal-contentWrapper mt-TransactionSellerCheckContractsModal-contentWrapper--withIcon">
                    <div className="mt-TransactionSellerCheckContractsModal-contentIcon">
                      <IconShieldUserOutline size={ATOM_ICON_SIZES.medium} />
                    </div>
                    <div className="mt-TransactionSellerCheckContractsModal-contentText">
                      <div className="mt-TransactionSellerCheckContractsModal-contentTextTitle">
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.AGENT_MANDATE.TITLE')}
                      </div>
                      <span>{i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.AGENT_MANDATE.DESCRIPTION')}</span>
                    </div>
                  </div>
                  <div className="mt-TransactionSellerCheckContractsModal-contentWrapper mt-TransactionSellerCheckContractsModal-contentWrapper--withIcon">
                    <div className="mt-TransactionSellerCheckContractsModal-contentIcon">
                      <IconCertifiedOutline size={ATOM_ICON_SIZES.medium} />
                    </div>
                    <div className="mt-TransactionSellerCheckContractsModal-contentText">
                      <div className="mt-TransactionSellerCheckContractsModal-contentTextTitle">
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.AFFIDAVIT.TITLE')}
                      </div>
                      <span>{i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.AFFIDAVIT.DESCRIPTION')}</span>
                    </div>
                  </div>
                </div>
              ),
              headerImage: (
                <div className="mt-TransactionModal-contentHeaderImageWrapper">
                  <AtomImage
                    alt={i18n.t('VEHICLE_TRANSACTION.CHECK_CONTRACTS.TITLE')}
                    className="mt-TransactionModal-contentHeaderImage"
                    src={imageUrl}
                  />
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.CHECK_CONTRACTS.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
